// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

const EXPIRED_AUTH_CODE_RETRY_KEY = "riddle.auth.expiredAuthCodeRetry";

export function hasAttemptedExpiredAuthCodeRetry(): boolean {
  try {
    return window.sessionStorage.getItem(EXPIRED_AUTH_CODE_RETRY_KEY) !== null;
  } catch {
    return true;
  }
}

export function markExpiredAuthCodeRetry(): void {
  try {
    window.sessionStorage.setItem(EXPIRED_AUTH_CODE_RETRY_KEY, "1");
  } catch {
  }
}

export function clearExpiredAuthCodeRetry(): void {
  try {
    window.sessionStorage.removeItem(EXPIRED_AUTH_CODE_RETRY_KEY);
  } catch {
  }
}
